import React from 'react';
import { ReactSVG } from 'react-svg';
import { FormattedMessage } from 'react-intl';
import CustomBtn from '../../../../../generic/CustomBtn';
import planetImg from '../../../../../assets/image/wizard/planet.svg';
import GeoJsonUploader from '../../AnotherComponents/GeoJsonUploader';

const PrevScreenLocation = ({ translate, jsonFile, setJsonFile, setShowMap, prevPage }) => (
  <div className="prev-screen">
    <div className="prev-screen__wrapper">
      <div className="prev-screen__img">
        <ReactSVG src={planetImg} />
      </div>
      <div className="prev-screen__desc">
        <h2 className="prev-screen__title">
          {translate.formatMessage({ id: 'wizardForm.step2.prev.title' })}
        </h2>
        <FormattedMessage
          id="wizardForm.step2.prev.description"
          values={{
            p: (...chunks) => <p className="prev-screen__text">{chunks}</p>,
            bold: (chunks) => <b>{chunks}</b>,
          }}
        />
      </div>
      <div className="prev-screen__panel-btn">
        <div className="prev-screen__wrap-btn">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-drawZone' })}
            handleClick={() => setShowMap(true)}
            iconClass="icon-marker"
            customClass="btn__map"
          />
        </div>
        <div className="prev-screen__wrap-btn">
          <GeoJsonUploader
            jsonFile={jsonFile}
            setJsonFile={setJsonFile}
            setShowMap={setShowMap}
          />
        </div>
        <div className="prev-screen__wrap-btn">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-back' })}
            handleClick={() => prevPage()}
            type="button"
            customClass="btn__cancel"
          />
        </div>
        <div className="prev-screen__wrap-btn">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-next' })}
            handleClick={() => {}}
            type="submit"
            customClass="btn__cancel"
          />
        </div>
      </div>
    </div>
  </div>
);

export default PrevScreenLocation;
